import * as React from 'react';

import { concatStyleSets, IStyle, ITheme, memoizeFunction, mergeStyles } from '@fluentui/react';

import { AppColors, getModernUxExperimentPreference, getPrimaryControlSemanticColorsWithTheme } from '@1js/acui-common';

import { SelectedPivotIndicatorDirection } from './SelectedPivotIndicator.Props';

export interface SelectedPivotIndicatorStyles {
  root?: IStyle;
}

export interface SelectedPivotIndicatorClassNames {
  root: string;
}

const getPivotColor = memoizeFunction((theme: ITheme, appColors?: AppColors): string | undefined => {
  const actionControlSemanticColors = getPrimaryControlSemanticColorsWithTheme(theme, appColors);
  return actionControlSemanticColors.primaryTextColor;
});

export const getSelectedPivotIndicatorStyles = memoizeFunction(
  (
    position: number,
    offset: number,
    length: number,
    thickness: number,
    showAnimation: boolean,
    direction: SelectedPivotIndicatorDirection,
    theme: ITheme,
    appColors?: AppColors,
    styles?: SelectedPivotIndicatorStyles
  ): SelectedPivotIndicatorStyles => {
    const vertical = direction === SelectedPivotIndicatorDirection.Vertical;
    const modernUxExperimentPreference = getModernUxExperimentPreference();
    const backgroundColor = getPivotColor(theme, appColors);
    const borderRadius = modernUxExperimentPreference ? '2px 2px 0 0' : 0;
    return concatStyleSets(
      {
        root: {
          margin: 0,
          top: vertical ? position : -1 * (thickness + offset),
          left: vertical ? offset : position,
          width: vertical ? thickness : length,
          height: vertical ? length : thickness,
          pointerEvents: 'none',
          position: 'relative',
          transition: showAnimation ? 'all 400ms cubic-bezier(0.17, 0.17, 0.00, 1.00)' : undefined,
          float: 'left',
          backgroundColor,
          borderRadius,
        },
      },
      styles
    );
  }
);

export const getPlaceHolderStyles = memoizeFunction(
  (theme: ITheme, appColors?: AppColors, customStyles?: React.CSSProperties): React.CSSProperties => {
    return {
      height: 3,
      margin: '0px 15px',
      top: -3,
      width: 'calc(100% - 30px)',
      backgroundColor: getPivotColor(theme, appColors),
      position: 'relative',
      ...customStyles,
    };
  }
);

export const getSelectedPivotIndicatorClassNames = memoizeFunction(
  (styles: SelectedPivotIndicatorStyles): SelectedPivotIndicatorClassNames => {
    return {
      root: mergeStyles(styles.root),
    };
  }
);
